import cn from "classnames";
import s from "./Loading.module.scss";

const Loading = ({ className, size = 14 }) => {
  const bubbleStyles = {
    width: `${size}px`,
    height: `${size}px`,
  };

  const stylesForNotFirst = {
    ...bubbleStyles,
    marginLeft: `${size * 1.5}px`,
  };

  return (
    <div className={cn(s.loading, className)}>
      <div className={s.container}>
        <div className={cn(s.bubble, s.bubble1)} style={bubbleStyles} />
        <div className={cn(s.bubble, s.bubble2)} style={stylesForNotFirst} />
        <div className={cn(s.bubble, s.bubble3)} style={stylesForNotFirst} />
      </div>
    </div>
  );
};

export default Loading;
